module.exports = __webpack_public_path__ + "static/media/AfhLogo.7499c9af.png";